import { render, staticRenderFns } from "./ScreenTime.vue?vue&type=template&id=5cd00a47&scoped=true&"
import script from "./ScreenTime.vue?vue&type=script&lang=js&"
export * from "./ScreenTime.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTime.vue?vue&type=style&index=0&id=5cd00a47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd00a47",
  null
  
)

export default component.exports